import React from 'react';

const WordPressComForm = () => {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-gray-700 font-medium mb-2">
          Integration Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          className="w-full border border-gray-300 rounded-md p-2"
          placeholder="My WordPress.com Website"
        />
      </div>

      <button className="w-full py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">
        Create
      </button>
    </div>
  );
};

export default WordPressComForm;

